import { GItem } from "./GItem";
import { Item } from "./Item";
import { SItem } from './SItem';

export class EmployeeReference {
    constructor(data: EmployeeReference = null) {
        if (data !== null) {
            this.companies = data.companies;
            this.branches = data.branches;
            this.unions = data.unions;
            this.jobRoles = data.jobRoles;
            this.tradeSkills = data.tradeSkills;
            this.userFeatures = data.userFeatures;
            this.trainingCategories = data.trainingCategories;
            this.costCenters = data.costCenters;
            this.states = data.states;
            this.managers = data.managers;
            this.trades = data.trades;
            this.skillRatings = data.skillRatings;
            this.departments = data.departments;
            this.secJobRoles = data.secJobRoles;
            this.secTemplates = data.secTemplates;
            this.incentivePrograms = data.incentivePrograms;
            this.payrollCompanyCodes = data.payrollCompanyCodes
            this.jobTitles = data.jobTitles;
            this.applyTypes = data.applyTypes;
            this.unionJobRoles = data.unionJobRoles;
            this.timeTypes = data.timeTypes;
        }
    }
    companies: GItem[] = null;
    branches: GItem[] = null;
    unions: GItem[] = null;
    jobRoles: GItem[] = null;
    unionJobRoles: GItem[] = null;
    jobTitles: GItem[] = null;
    tradeSkills: GItem[] = null;
    userFeatures: GItem[] = null;
    trainingCategories: GItem[] = null;
    costCenters: Item[] = null;
    states: SItem[] = [];
    managers: GItem[] = null;
    trades: Item[] = null;
    skillRatings: Item[] = null;
    departments: GItem[] = null;
    secJobRoles: GItem[] = null;
    secTemplates: GItem[] = null;
    incentivePrograms: GItem[] = null;
    applyTypes: Item[] = null;
    payrollCompanyCodes: GItem[] = null
    timeTypes: GItem[] = null;
    getJobRoleDescription(id: any): string {
        if (this.jobRoles) {
            let item: GItem = this.jobRoles.find(s => s.value === id);
            if (item) { return item.description; }
        }
        return "";
    }
    getTimeType(id: any): string {
        if (this.timeTypes) {
            let item: GItem = this.timeTypes.find(s => s.value === id);
            if (item) { return item.description; }
        }
        return "";
    }
    getUnion(id: any): string {
        if (this.unions) {
            let item: GItem = this.unions.find(s => s.value === id);
            if (item) {
                return item.description;
            }
        }
        return "";
    }
    getApplyType(id: any): string {
        if (this.applyTypes) {
            let item: Item = this.applyTypes.find(s => s.value === id);

            return item.description;
        }
        return "";
    }
    getJobTitleDescription(id: any): String {
        if (this.jobTitles && id) {
            let item: GItem = this.jobTitles.find(s => s.value === id);
            if (item) {
                return item.description;
            }
        }
        return "";
    }
}
